export default __webpack_public_path__ + "static/media/mems.971578b0.svg";